export const getGenericInputStylesCP = (image, showIcon) => {
  return {
    input: {
      color: "#848484",
      border: "none",
      borderBottom: "1px solid #d6d6d6",
      width: "100%",
      fontSize: "16px",
      fontFamily: "AMX-Regular",
      backgroundImage: `url(${showIcon ? image : ""})`,
      backgroundPosition: "right 0px center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20px",
      height: "30px",
      backgroundColor: "#fff",
    },
  };
};

export const getGenericInputStylesContainerTelcel = () => {
  return {
    wrapper: {
      display: "none",
    },
  };
};
